import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApplicationRoutes } from 'src/constants/applicationRoutes';
import {
  profileInitialSectionStateKey,
  type TabValue
} from 'src/features/userProfileRefactor/travelerProfileConstants';

/**
 * Canonical profile route helpers.
 */
export function useObtProfileNav() {
  const navigate = useNavigate();

  /**
   * Programmatic same-window navigation that lands the user on the Card section.
   * Passes a one-time `location.state` signal so TravelerProfileView can seed
   * the active tab.
   * Wrapped here because react-router's `navigate(to, options)` requires `state`
   * in the options arg - placing it on the `to` object silently drops it.
   */
  const goToCardSection = useCallback(() => {
    navigate(ApplicationRoutes.account.userProfileRefactor, {
      state: { [profileInitialSectionStateKey]: 'card' satisfies TabValue }
    });
  }, [navigate]);

  return {
    profilePath: ApplicationRoutes.account.userProfileRefactor,
    userProfilesLabel: 'User Profiles',
    myProfileLabel: 'My Profile',
    goToCardSection
  };
}
